import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const GuestCounter = styled.span`
  width: 100%;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 16px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const GuestRow = styled.div`
  margin: 0;
  border-bottom: 1px solid ${({ theme }) => theme.tertiaryColour};
  min-width: 100px;
  position: relative;

  ${media.sm`
    display: flex;
    flex-direction: column;
    border-bottom: none;
    margin: 0;
  `}

  ${media.xs`
    border-bottom: none;
    padding: 0px 0;
  `}
`;

export const InputsRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 17px 0 0 0;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: column;

  ${media.sm`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  `}

  ${media.xs`
    padding-right: 0px;
  `}
`;

export const GuestColumn = styled.div`
  flex-grow: 1;
  min-width: 130px;
  margin-top: 20px;
  width: 100%;

  &:first-child {
    max-width: 150px;
    margin-top: 0px;
  }

  ${media.md`
    width: auto;
    padding: 0 0 0 20px;
    margin-top: 0px;
    height: 94px;
    &:first-child {
      padding-left: 0px;
    }
  `}
`;

export const TitleText = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  width: 100%;
`;

export const GenderRow = styled.div`
  margin-top: 20px;
`;
